import axios from 'axios';
import { TGetRankingFemale } from 'types';
import { TResFemaleRanking } from 'types/ranking';

const getFemaleRanking = async (
  params: TGetRankingFemale,
): Promise<TResFemaleRanking[]> => {
  const response = await axios.get('/ranking/female', { params });

  return response.data;
};

export { getFemaleRanking };
